/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Error_Email_InvalidInputs */

const en_contact_error_email_invalid = /** @type {(inputs: Contact_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid email address`)
};

const lv_contact_error_email_invalid = /** @type {(inputs: Contact_Error_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lūdzu, ievadiet derīgu e-pasta adresi`)
};

/**
* | output |
* | --- |
* | "Please enter a valid email address" |
*
* @param {Contact_Error_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_error_email_invalid = /** @type {((inputs?: Contact_Error_Email_InvalidInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Error_Email_InvalidInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_error_email_invalid(inputs)
	return en_contact_error_email_invalid(inputs)
});